/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RegexPasswordValidationRule } from './RegexPasswordValidationRule';
import {
    RegexPasswordValidationRuleFromJSON,
    RegexPasswordValidationRuleFromJSONTyped,
    RegexPasswordValidationRuleToJSON,
} from './RegexPasswordValidationRule';

/**
 * 
 * @export
 * @interface PasswordValidationRuleset
 */
export interface PasswordValidationRuleset {
    /**
     * 
     * @type {Array<RegexPasswordValidationRule>}
     * @memberof PasswordValidationRuleset
     */
    regular_expressions?: Array<RegexPasswordValidationRule>;
}

/**
 * Check if a given object implements the PasswordValidationRuleset interface.
 */
export function instanceOfPasswordValidationRuleset(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PasswordValidationRulesetFromJSON(json: any): PasswordValidationRuleset {
    return PasswordValidationRulesetFromJSONTyped(json, false);
}

export function PasswordValidationRulesetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordValidationRuleset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'regular_expressions': !exists(json, 'regular_expressions') ? undefined : ((json['regular_expressions'] as Array<any>).map(RegexPasswordValidationRuleFromJSON)),
    };
}

export function PasswordValidationRulesetToJSON(value?: PasswordValidationRuleset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'regular_expressions': value.regular_expressions === undefined ? undefined : ((value.regular_expressions as Array<any>).map(RegexPasswordValidationRuleToJSON)),
    };
}

